module.exports = __webpack_public_path__ + "img/gw2.47720f62.png";